import axios from "axios";
import React, {useEffect, useState,useRef} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";

import "../../components/assets/css/profile.css"

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../assets/img/Rectangle 305.png";



const serialize = require('form-serialize');


const Panel = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_order_get,setData_list_order] = useState([]);
    /*  end profile */

    const [email_address_user, setemail_address_user] = useState('');
    const [phone_user, set_phone_user] = useState('');


    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
           ///redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");

        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`,null,config)
            .then((res) => {
                Setloadinghkfullshow("false");
///console.log(res.data);
                if(String(res.data).length > 0) {

                    if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  } ////dddddd

                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }
                    if (!empty_bk(res.data.email_address_user) && String(res.data.email_address_user)!="undefined") { setemail_address_user(res.data.email_address_user);  }else{  setemail_address_user(''); }


                  ///  if(String(res.data.data.total_cource_order).length  > 0) {  setData_total_cource_order(res.data.data.total_cource_order); }
                 if(String(res.data.data.list_order).length > 0) {  setData_list_order(res.data.data.list_order); }

                    if (!empty_bk(res.data.phone_mobile) && String(res.data.phone_mobile)!="undefined") { set_phone_user(res.data.phone_mobile);  }else{  set_phone_user(''); }






                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
             Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }



    const Handler_saved_profile_pr= () => {

        if(check_login_appbk()==false){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" ); }

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_data_profile');
        if (form_data != null) {

            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/profile-edit-pr/`,data_serialize,config)
                .then((res) => {

                    Setloadinghkfullshow("false");

                    if(String(res.data).length > 0) {

                        if(String(res.data.data)=="login-show"){  redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  }



                        if(String(res.data.status)=="success"){
                            toast.success(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }else{

                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }





                    }else{
                        if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 6786324', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            });





        }






    }

    const Handler_Chanche_first_name=(event)=>{
        setData_first_name_profile(convert_to_english_strhk(event.target.value));
    }

    const Handler_Chanche_last_name=(event)=>{
        setData_last_name_profile(convert_to_english_strhk(event.target.value));
    }

    const Handler_Chanche_email_address_user = (event) => {
        setemail_address_user(String(convert_to_english_strhk(event.target.value)));
    }

    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>

                            <section className='account-content'>

                                <div className={"title_page_panel"} style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}>اطلاعات من</span></div>
                                </div>



                                <div className='w-100 flexRowBetCenter'>

                                    <form id="form_data_profile">

                                        <div style={{"padding":"12px","width":"100%"}}>
                                            <Grid container direction="row" spacing={2} style={{paddingTop:"5px"}}>

                                                <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"7px"}}>
                                                    <label className={"lable_input_panel requirebk-input"}  id={"first_name"} >نام</label>
                                                    <input value={first_name_profile} onChange={Handler_Chanche_first_name}  type="text" className="inputbox_bk_panel" name="first_name"   />
                                                </Grid>


                                                <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"7px"}}>
                                                    <label className={"lable_input_panel requirebk-input"} id={"last_name"} >نام خانوادگی</label>
                                                    <input value={last_name_profile} onChange={Handler_Chanche_last_name}   type="text" className="inputbox_bk_panel" name="last_name"   />
                                                </Grid>








                                                <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"8px",marginBottom:"0px"}}>
                                                    <label  id={"email_address_user"} className={"lable_input_panel requirebk-input"}>ایمیل(اختیاری)</label>
                                                    <input value={email_address_user} onChange={Handler_Chanche_email_address_user}   type="text" className="inputbox_bk_panel" name="email_address_user"  />
                                                </Grid>


                                                <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"8px",marginBottom:"0px"}}>
                                                    <label  id={"phone_address_user"} style={{"marginBottom":"3px"}} className={"lable_input_panel requirebk-input"}>شماره موبایل</label>
                                                    <input value={phone_user}  disabled={true}   type="text" className="inputbox_bk_panel" name="phone_address_user" style={{"backgroundColor":"#f9f9f9c4","padding":"9px"}}  />
                                                </Grid>






                                            </Grid>

                                            <button   type="button"  onClick={Handler_saved_profile_pr} className="btn-bh btn-bon-bh" style={{"height":"45px","marginTop":"31px","fontFamily":"'iran'","fontSize":"17px"}} >ذخیره</button>



                                        </div>
                                    </form>

                                </div>

                            </section>


                        </Grid>






                    </Grid>






                </section>










            </Master_Front>

        </>
    );
}


export default Panel;